"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurvicateSDK = void 0;
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var auth_handler_1 = require("../../utils/auth-handler");
var jwt_handler_1 = require("../../utils/jwt-handler");
var base_1 = require("../base");
var instance_1 = require("./instance");
var SurvicateSDK = (function (_super) {
    tslib_1.__extends(SurvicateSDK, _super);
    function SurvicateSDK(config) {
        var _this = this;
        var providerKey = config.providerKey;
        _this = _super.call(this) || this;
        _this.onReady = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var user;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(window && window._sva)) return [3, 2];
                        window._sva.addEventListener('survey_closed', this.collectSurveyInteraction('dismissed'));
                        window._sva.addEventListener('survey_displayed', this.collectSurveyInteraction('displayed'));
                        window._sva.addEventListener('question_answered', this.collectSurveyInteraction('answered'));
                        window._sva.addEventListener('survey_completed', this.collectSurveyInteraction('completed'));
                        return [4, jwt_handler_1.JWTHandler.getUserFromToken()];
                    case 1:
                        user = _a.sent();
                        this.instance = window._sva;
                        this.instance.setVisitorTraits(user);
                        window.dispatchEvent(new CustomEvent('FeedbackSDKReady'));
                        this.ready = true;
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        }); };
        _this.ready = false;
        (0, instance_1.initializeSurvicate)(providerKey);
        window.addEventListener('SurvicateReady', function () {
            _this.onReady().finally(function () { return null; });
        });
        return _this;
    }
    SurvicateSDK.prototype.showSurvey = function (targetEvent, option) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var surveyId;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getSurveyId(targetEvent)];
                    case 1:
                        surveyId = _a.sent();
                        return [2, this.instance.showSurvey(surveyId, tslib_1.__assign({ forceDisplay: true }, option))];
                }
            });
        });
    };
    SurvicateSDK.prototype.showGenericSurvey = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var surveyId;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getGenericSurvey()];
                    case 1:
                        surveyId = _a.sent();
                        return [2, this.instance.showSurvey(surveyId, { forceDisplay: true })];
                }
            });
        });
    };
    SurvicateSDK.prototype.showSuggestionSurvey = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var surveyId;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getSuggestionSurvey()];
                    case 1:
                        surveyId = _a.sent();
                        return [2, this.instance.showSurvey(surveyId, { forceDisplay: true })];
                }
            });
        });
    };
    SurvicateSDK.prototype.collectEventOfInterest = function (eventOfInterest, isOncePerSession) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var currentVisitor, currentCookie, isVisitorMatchInCookie, cookie, _a;
            var _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        currentVisitor = this.instance.getVisitorId();
                        currentCookie = jwt_handler_1.JWTHandler.getCookie('eventOfInterest');
                        isVisitorMatchInCookie = currentVisitor === (currentCookie === null || currentCookie === void 0 ? void 0 : currentCookie[eventOfInterest]);
                        cookie = tslib_1.__assign(tslib_1.__assign({}, currentCookie), (_b = {}, _b[eventOfInterest] = currentVisitor, _b));
                        if (isOncePerSession && isVisitorMatchInCookie)
                            return [2];
                        SurvicateSDK.setEventOfInterestJWTCookie(cookie);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4, this.postEventOfInterest(eventOfInterest)];
                    case 2:
                        _c.sent();
                        return [3, 4];
                    case 3:
                        _a = _c.sent();
                        (0, lodash_1.unset)(cookie, eventOfInterest);
                        SurvicateSDK.setEventOfInterestJWTCookie(cookie);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    Object.defineProperty(SurvicateSDK.prototype, "isReady", {
        get: function () {
            return this.ready;
        },
        enumerable: false,
        configurable: true
    });
    SurvicateSDK.prototype.onSDKReady = function (callback) {
        var eventFunction = callback;
        if (this.ready) {
            eventFunction();
        }
        else {
            window.addEventListener('FeedbackSDKReady', eventFunction);
        }
    };
    SurvicateSDK.prototype.setAuthConfiguration = function (authConfiguration) {
        auth_handler_1.AuthHandler.setAuthConfiguration(authConfiguration);
    };
    return SurvicateSDK;
}(base_1.FeedbackSDK));
exports.SurvicateSDK = SurvicateSDK;
//# sourceMappingURL=index.js.map